// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2AaGf","amount":"Amount_amount__1OtpY","tip":"Amount_tip__ebQWZ","tipHeader":"Amount_tipHeader__hNmWs","tipsWrap":"Amount_tipsWrap__2LhzS"};